module.exports = __webpack_public_path__ + "static/media/play-small-icon.75bcc1a3.svg";